<template>
  <div class="catalog-info fl">
    <ul class="cate-menu">
      <template v-for="(item, index) in catalogList">
        <li :key="index" class="catalog-li">
          <div style="position: relative;">
            <img class="pr-5 catalog-img" :src="item.coverUrl" />
            <div class="pl20 catalog-item ell">
              <template v-for="(item1, index1) in item.children">
                <el-link
                  :key="index1"
                  :underline="false"
                  @click="handleClickCategory(item1)"
                  class="mr5"
                  >{{ item1.categoryName }}</el-link
                >
              </template>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import store from "../../../config/store";

export default {
  name: "catalog",
  mixins: [mixinHomePage],
  data() {
    return {};
  },
  activated() {
    this.init();
  },
  methods: {
    init() {}
  },
  computed: {
    catalogList() {
      console.log(store.state.user.catalogList, "store");
      return store.state.user.catalogList;
    }
  }
};
</script>

<style scoped lang="scss">
.catalog-item /deep/ .el-link--default {
  position: static;
}
</style>
